import { ConnectResult, create, createPromiseClient } from '@/connect';
import {
  ContractService,
  ListContractHistoryFilter,
  ListContractHistoryResponse,
  ListContractHistorySortSchema,
} from '@/connect/gen/modules/apiengine/services/contracts/contracts_pb';
import { ContractHistorySortableField, SortOrder } from '@/connect';
import { SortModelItem } from 'ag-grid-enterprise';

export const loansService = new (class {
  public readonly promiseClient = createPromiseClient(ContractService);

  public async listContractHistory(
    config: {
      page: number;
      pageSize: number;
      sort: SortModelItem;
      filter: ListContractHistoryFilter;
      signal: AbortSignal;
    },
    asCompanyId?: string // brokers can view-as-company
  ): Promise<ConnectResult<ListContractHistoryResponse>> {
    const sortFields: Record<string, ContractHistorySortableField> = {
      'contractState.openQuantity': ContractHistorySortableField.OPEN_QUANTITY,
      'contractState.counterpartyId': ContractHistorySortableField.COUNTERPARTY,
      'contractState.instrument.ticker': ContractHistorySortableField.INSTRUMENT_TICKER,
      'contractState.instrument.cusip': ContractHistorySortableField.INSTRUMENT_CUSIP,
      'contractState.openQuantityChange': ContractHistorySortableField.OPEN_QUANTITY_CHANGE,
      'contractState.rateDetails': ContractHistorySortableField.RATE,
      'contractState.contractValue': ContractHistorySortableField.SETTLEMENT_AMOUNT,
      'contractState.contractValueAdjustment':
        ContractHistorySortableField.SETTLEMENT_AMOUNT_CHANGE,
      'contractState.interestDueAmount': ContractHistorySortableField.RATE_AMOUNT,
      'contractState.settlementType': ContractHistorySortableField.SETTLEMENT_TYPE,
      eventType: ContractHistorySortableField.EVENT_TYPE,
      eventTime: ContractHistorySortableField.EVENT_TIME,
      initiator: ContractHistorySortableField.INITIATOR,
      side: ContractHistorySortableField.SIDE,
      'contractState.settlementDate': ContractHistorySortableField.SETTLEMENT_DATE,
    };

    const field = config.sort.colId;
    const order = config.sort.sort === 'asc' ? SortOrder.ASC : SortOrder.DESC;
    const sorts =
      field in sortFields
        ? [create(ListContractHistorySortSchema, { field: sortFields[field], order })]
        : [];
    const query = {
      filter: config.filter,
      sorts,
      pageNumber: config.page,
      pageLimit: config.pageSize,
    };
    const result = await this.promiseClient.listContractHistory(query, {
      ...(asCompanyId && { headers: { 'As-Company': asCompanyId } }),
    });
    return result as ConnectResult<ListContractHistoryResponse>;
  }
})();
